import { HeroPhoto } from "@/components/marketplace"
import type { HeroSlide } from "@/components/marketplace/hero/hero-carousel"
import type { HeroPhotoSection } from "@/features/feed/contract"
import { resolveFeedLink } from "@/features/feed/resolve-link"
import { SectionFrame } from "@/features/feed/sections/SectionFrame"
import type { FeedSectionProps } from "@/features/feed/sections/types"

export const HeroPhotoFeedSection = ({ section, context }: FeedSectionProps<HeroPhotoSection>) => {
  const slides: HeroSlide[] = section.data.slides.map((slide) => ({
    title: slide.title,
    accent: slide.accent,
    sub: slide.sub,
    cta: slide.cta?.label,
    ctaHref: slide.cta ? resolveFeedLink(slide.cta.link, context.countryCode, context.page) : undefined,
    image: slide.image?.url,
    imageWide: slide.imageWide?.url,
    imageAlt: slide.image?.alt,
    serveId: slide.serveId,
  }))
  if (slides.length === 0) return null
  return (
    <SectionFrame section={section} context={context} ownsHeader>
      <HeroPhoto slides={slides} priority={context.isLeadSection} compact={section.presentation.variant === "compact"} />
    </SectionFrame>
  )
}
